import { Site } from "@/shared/Site";
import moment from "moment/moment";
export default class GraphData {
  public labels?: any[] = [];
  public datasets: DataSet[] = [];
  // constructor( ) {}
}

export class DataSet {
  public label: string = "";
  public backgroundColor?: string = "rgba(255,255,255,0.2)";
  public data: number[] = [];
  public borderColor?: string = "white";
  public borderWidth?: number = 1;
  public pointBackgroundColor?: string = "transparent";
  public pointBorderColor?: string = "transparent";
  public defaultColor: string = "white";
  public typePeriode?: string;
  public periodeLabels?: any;
}

export class MyOptions {
  public updateMe: number = 0;
  public colors: string[] = ["white"];
  public titre: string = "";
  public periode: string = "J";
  public site: Site[] = [];
  public date: Date = new Date();
  public service: string = "GLOBAL";
}

export class ChartOptions {
  public responsive: boolean = true;
  public maintainAspectRatio: boolean = false;
  public legend: any;
  public tooltips: any;
  public title: any;
  public scales: any;
  public animation = { duration: 0 };
  public plugins: any = {};
  public layout: any;

  public elements = {
    line: {
      borderWidth: 1,
      borderColor: "white",
    },
    arc: {
      borderWidth: 0,
    },
  };

  constructor() {
    this.legend = {
      display: true,
      labels: {
        filter: (legendItem: any, data: any) => {
          return false;
        },
      },
    };
    this.tooltips = {
      enabled: true,
      bodyFontSize: 16,
      mode: "x-axis",
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          // console.log(data, tooltipItem);
          let date = "";
          const dataset = data.datasets[tooltipItem.datasetIndex];
          // let idex = tooltipItem.index;
          if (dataset.typePeriode === "J") {
            date = moment(dataset.label, "DD/MM/YYYY").format("DD MMM YY");
            date += " " + tooltipItem.xLabel;
          } else if (dataset.typePeriode === "SEMAINE") {
            date = moment(dataset.label, "w YYYY").format("YY");
            date = tooltipItem.xLabel + " " + date;
          } else if (dataset.typePeriode === "MOIS") {
            date = moment(dataset.label, "MM/YYYY").format("YY");
            date = tooltipItem.xLabel + " " + date;
          } else if (dataset.typePeriode === "ANNEE") {
            date = moment(dataset.label, "YYYY").format("YY");
            const month = moment(tooltipItem.xLabel, "MMMM YYYY").format(
              "MMMM"
            );
            date = month + " " + date;
          }
          return (
            date +
            " : " +
            Number(tooltipItem.yLabel).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          ); // + currency;
        },
        title: () => {
          return null;
        },
        labelColor: (tooltipItem: any, chart: any) => {
          const dataset = chart.config.data.datasets[tooltipItem.datasetIndex];
          return {
            backgroundColor: dataset.backgroundColor,
          };
        },
      },
    };
    this.title = {
      display: true,
      position: "top",
      fontColor: "#fff",
      fontSize: 15,
    };
    this.scales = {
      gridLines: {
        display: false,
        color: "#ffffff",
      },
      scaleLabel: {
        fontColor: "#fff",
      },
      yAxes: [
        {
          ticks: {
            fontColor: "#fff",
          },
          gridLines: {
            display: false,
            color: "#ffffff",
          },
          scaleLabel: {
            display: false,
            labelString: "€",
            fontColor: "#fff",
          },
        },
      ],
      xAxes: [
        {
          type: "time",
          time: {
            unit: "day",
            displayFormats: { hour: "DD" },
            tooltipFormat: "ddd DD",
          },
          ticks: {
            fontColor: "#fff",
          },
          gridLines: {
            display: false,
            color: "#ffffff",
          },
        },
      ],
    };
    this.layout = {
      padding: {
        left: 0,
        right: 0,
      },
    };
  }

  public setTitleTxt(title: string) {
    this.title.text = title;
  }

  public showLegend(showLegend: boolean) {
    this.legend.display = showLegend;
    this.legend.position = "bottom";
    this.legend.color = "#ffffff";
    this.legend.labels = {
      fontColor: "#ffffff",
    };
  }

  public updateLegendPeriod(periode: string) {
    this.scales.xAxes[0] = {};

    const axe = this.scales.xAxes[0];

    axe.gridLines = {
      display: false,
      drawBorder: false,
    };

    if (periode === "QUART_JOUR") {
      axe.type = "category";
      axe.ticks = {
        autoSkip: false,
        maxRotation: 45,
        minRotation: 45,
        fontColor: "#fff",
      };
      axe.gridLines = {
        display: false,
        drawBorder: false,
      };
    } else {
      axe.type = "time";
      axe.time = {
        parser: "YYYY-MM-DDTHH:mm:ss.SSSZ",
        displayFormats: {},
        tooltipFormat: "",
      };

      switch (periode) {
        case "J":
          axe.time.unit = "hour";
          axe.time.displayFormats = { hour: "HH:mm" };
          axe.time.tooltipFormat = "HH:mm";
          break;
        case "SEMAINE":
          axe.time.unit = "day";
          axe.time.displayFormats = { day: "ddd" };
          axe.time.tooltipFormat = "DD MMM";
          break;
        case "MOIS":
          axe.time.unit = "day";
          axe.time.displayFormats = { day: "DD MMM" };
          axe.time.tooltipFormat = "DD MMM";
          break;
        case "ANNEE":
          axe.time.unit = "month";
          axe.time.displayFormats = { month: "MMM YYYY" };
          axe.time.tooltipFormat = "MMM YYYY";
          break;
      }

      axe.ticks = {
        autoSkip: true,
        maxRotation: 30,
        minRotation: 0,
        fontColor: "#fff",
      };
    }
  }

  public setMaintainOptionRatio(maintain: boolean) {
    this.maintainAspectRatio = maintain;
  }

  public setReponsive(responsive: boolean) {
    this.responsive = this.responsive;
  }

  public setTooltipsCallBack(tolltips: any) {
    this.tooltips.callbacks = tolltips;
  }

  public makeMeADoughnut() {
    this.tooltips.callbacks.label = (tooltipItem: any, data: any) => {
      return (
        data.labels[tooltipItem.index] +
        " : " +
        data.datasets[0].data[tooltipItem.index] +
        "€"
      );
    };
    this.plugins = {
      datalabels: {
        display: (context: any) => {
          return context.dataset.data[context.dataIndex] !== 0;
        },
        formatter: (value: any, context: any) => {
          // console.log(value, context);
          return value + " €";
        },
        // render: "value",
        fontColor: "#ffffff",
        color: "white",
        precision: 2,
        overlap: true,
        value: {
          color: "white",
        },
      },
    };
    this.scales = {};
    this.showLegend(false);
    this.responsive = true;
    this.maintainAspectRatio = false;
    this.title.display = true;
    this.title.fontColor = "#616161";
    this.title.position = "bottom";
  }

  public makeMeADoughnutWithoutLabels() {
    this.tooltips.callbacks.label = (tooltipItem: any, data: any) => {
      return (
        data.labels[tooltipItem.index] +
        " : " +
        data.datasets[0].data[tooltipItem.index] +
        "€"
      );
    };
    this.plugins = {
      datalabels: {
        display: (context: any) => {
          return context.dataset.data[context.dataIndex] !== 0;
        },
        formatter: (value: any, ctx: any) => {
          let sum = 0;
          const dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map((data: any) => {
            sum += data;
          });
          const percentage = ((value * 100) / sum).toFixed(2) + " %";
          return percentage;
        },
        precision: 2,
        color: "white",
        font: {
          weight: "bold",
        },
      },
    };
    this.scales = {};
    this.showLegend(false);
    this.responsive = true;
    this.maintainAspectRatio = false;
    this.title.display = true;
    this.title.fontColor = "#616161";
    this.title.position = "top";
    this.title.fontSize = 24;
    this.title.fontFamily = "Quicksand";
    this.title.fontWeight = "bold";
  }

  public makeMeADoughnutWithoutLabelsAndPercentage() {
    this.tooltips.callbacks.label = (tooltipItem: any, data: any) => {
      return (
        data.labels[tooltipItem.index] +
        " : " +
        data.datasets[0].data[tooltipItem.index] +
        "€"
      );
    };
    this.plugins = {
      datalabels: {
        display: (context: any) => {
          return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
        },
        formatter: (value: any, ctx: any) => {
          return "";
        },
      },
    };
    this.scales = {};
    this.showLegend(false);
    this.responsive = true;
    this.maintainAspectRatio = false;
  }

  public makeMeAPercentDoughnut() {
    this.tooltips.callbacks.label = (tooltipItem: any, data: any) => {
      return (
        data.labels[tooltipItem.index] +
        " : " +
        data.datasets[0].data[tooltipItem.index] +
        "€"
      );
    };
    this.plugins = {
      datalabels: {
        display: (context: any) => {
          return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
        },
        formatter: (value: any, context: any) => {
          // console.log(value, context);
          return value.toFixed(2) + " %";
        },
        // render: "value",
        fontColor: "#ffffff",
        color: "white",
        precision: 2,
        overlap: true,
        value: {
          color: "white",
        },
      },
    };
    this.scales = {};
    this.showLegend(false);
    this.responsive = true;
    this.maintainAspectRatio = false;
  }

  public makeMeABarGraph() {
    this.showLegend(false);
    this.tooltips = { enabled: false };
    this.layout = {
      padding: {
        top: 15,
        bottom: 0,
      },
    };
    this.maintainAspectRatio = false;
    this.title.display = false;

    this.plugins = {
      datalabels: {
        display: (context: any) => {
          return context.dataset.data[context.dataIndex] !== 0;
        },
        formatter: (value: any, context: any) => {
          return value + " €";
        },
        fontColor: "#ffffff",
        color: "white",
        precision: 2,
        overlap: true,
        value: {
          color: "white",
        },
      },
    };

    this.scales = {
      gridLines: {
        display: false,
      },
      scaleLabel: {
        fontColor: "#fff",
      },
      yAxes: [
        {
          ticks: {
            fontColor: "#fff",
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: "€",
            fontColor: "#fff",
          },
        },
      ],
      xAxes: [
        {
          barPercentage: 0.5,
          stacked: false,
          type: "category",
          display: true,
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            fontColor: "#ffffff",
          },
          ticks: {
            autoSkip: false,
            fontColor: "#ffffff",
          },
        },
      ],
    };
  }

  public hideLabelPlugin() {
    this.plugins = {
      datalabels: {
        display: (context: any) => {
          return false;
        },
      },
    };
  }

  public makeMeACategoryLineGraph() {
    this.scales = {
      xAxes: [
        {
          type: "category",
          ticks: {
            fontColor: "#ffffff",
          },
          gridLines: {
            display: false,
            fontcolor: "#ffffff",
          },
          scaleLabel: {
            display: true,
            labelString: "Heure",
            fontColor: "#ffffff",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: "#ffffff",
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: "€",
            fontColor: "#ffffff",
          },
        },
      ],
    };
    this.plugins = {
      datalabels: {
        color: "#ffffff",
        anchor: (context: any) => {
          return context.dataIndex % 2 === 0 ? "end" : "start";
        },
        align: (context: any) => {
          return context.dataIndex % 2 === 0 ? "top" : "bottom";
        },
        font: {
          weight: "bold",
          size: 12,
        },
        display: (context: any) => {
          const maxVisible = 20;
          return (
            context.chart.data.labels.length <= maxVisible &&
            context.dataset.data[context.dataIndex] !== 0
          );
        },
        formatter: (value: number) => {
          return value.toFixed(2) + " €";
        },
      },
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
      tooltip: {
        titleColor: "#ffffcc",
        bodyColor: "#ffffcc",
        backgroundColor: "#000000",
      },
    };

    this.showLegend(true);
    this.responsive = true;
    this.maintainAspectRatio = false;
  }

  public showYLegend(show: boolean) {
    this.scales.yAxes[0].scaleLabel.display = show;
  }
}
